import React, { useEffect, useState, useRef } from "react";
import AOS from "aos";
import { Helmet } from "react-helmet";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import PublicLayout from "web/components/PublicLayout";
import LandingFooter from "web/pages/public/landing-page/LandingFooter";
import DigitalSupplier from "../../../../assets/images/1solution.svg";
import GetIcon1 from "../../../../assets/images/1get.svg";
import GetIcon2 from "../../../../assets/images/2get.svg";
import GetIcon3 from "../../../../assets/images/5get.svg";
import GetIcon4 from "../../../../assets/images/4get.svg";
import Specialties1 from "../../../../assets/images/1Specialties.svg";
import Specialties2 from "../../../../assets/images/2Specialties.svg";
import Specialties3 from "../../../../assets/images/3Specialties.svg";
import Specialties4 from "../../../../assets/images/4Specialties.svg";
import Specialties5 from "../../../../assets/images/5Specialties.svg";
import Specialties6 from "../../../../assets/images/6Specialties.svg";
import tickIcon from "../../../../assets/images/tickIcon34.svg";
import crossIcon from "../../../../assets/images/crossIcon34.svg";
import ButtonSet from "../ButtonSet";
import {
  Container,
  Wrapper,
  ColorBox,
} from "web/pages/public/landing-page/CustomizedSolutions/CustomizedSolutionsStyled";
import { logoutAdmin } from 'redux/actions/admin';
import { logoutClearRedux } from 'redux/actions/auth';

const data = [
  {
    title: ["Process", "Efficiency"],
    icon: GetIcon1,
    description: ["Total Order Management", "One Point of Contact"],
  },
  {
    title: ["Network", "Visibility"],
    icon: GetIcon2,
    description: ["Customized BI Dashboard with On-Demand KPIs"],
  },
  {
    title: ["Lowest TCO &", "Flexible Terms"],
    icon: GetIcon3,
    description: ["Optimized Pallet Costs", "Flexible Pricing Models"],
  },
  {
    title: ["Expert", "Resources"],
    icon: GetIcon4,
    description: ["Dedicated Account Reps", "Expert QC Team"],
  },
];


const CardDetails = ({ item, index, isOpen, onOpen, onClose }) => {
  const ref = useRef();
  const dispatch = useDispatch();
  let history = useHistory();

  useEffect(() => {
    let token = localStorage.getItem('token')
    let isAdminOrUserAccount = localStorage.getItem('accountType')
    if (isAdminOrUserAccount && token) {
      if (isAdminOrUserAccount === 'Admin') history.push('/admin')
      else history.push('/dashboard')
    } else {
      dispatch(logoutAdmin())
      dispatch(logoutClearRedux())
      localStorage.clear()
      sessionStorage.clear()
    }
  }, [])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, onClose]);

  const renderTitle = (title) => {
    if (Array.isArray(title)) {
      return title.map((line, idx) => (
        <React.Fragment key={idx}>
          {line}
          {idx < title.length - 1 && <br />}
        </React.Fragment>
      ));
    }
    return title;
  };

  return (
    <>
      <div className="card" data-aos="fade-right" data-aos-delay={index * 300} ref={ref}>
        <div className="text-box">
          <h4>{renderTitle(item?.title)}</h4>
          <p onClick={onOpen}>Read more</p>
          <div className={`hover-box ${isOpen ? 'active' : ''}`}>
            <img src={crossIcon} onClick={onClose} alt="close icon" />
            <h4>{renderTitle(item?.title)}</h4>
            <ul>
              {item?.description?.map((desc, descIndex) => (
                <li key={index + "description-" + descIndex}>
                  <img src={tickIcon} alt="tick icon" /> {desc}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="img-box">
          {typeof item.icon === "function" ? (
            item.icon()
          ) : (
            <img src={item.icon} alt="icon" />
          )}
        </div>
      </div>
    </>
  );
};


CardDetails.propTypes = {
  item: PropTypes.object,
  index: PropTypes.number,
  isOpen: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
};

const CustomizedSolutions = () => {
  const location = useLocation();
  const whatRef = useRef(null);
  const ourRef = useRef(null);
  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 320,
      once: true,
    });
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (location.hash === "#what") {
      if (whatRef.current) {
        // whatRef.current.scrollIntoView({ behavior: 'smooth' });
        const element = whatRef.current;
        const yOffset = -80; // Adjust the offset as needed
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }, [location]);

  useEffect(() => {
    if (location.hash === "#our") {
      if (ourRef.current) {
        // ourRef.current.scrollIntoView({ behavior: "smooth" });
        const element = ourRef.current;
        const yOffset = -80; // Adjust the offset as needed
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }, [location]);

  let history = useHistory();

  const [openIndex, setOpenIndex] = useState(null);

  const handleOpen = (index) => {
    setOpenIndex(index);
  };

  const handleClose = () => {
    setOpenIndex(null);
  };
  return (
    <>
      <Helmet title="Customized Pallet Solutions Tailored to Your Needs | PalletTrader">
        <meta
          name="description"
          content="With 40+ years of expertise and partnership with Bettaway Pallet Systems, PalletTrader offers innovative, customized pallet solutions for any need, big or small."
        />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/customized-pallet-solutions" />
      </Helmet>
      <PublicLayout transparentHeader={true}>
        <Container>
          <Wrapper>
            <section className="our_expertise suppliers mb-0">
              <div className="expertise_overlay">
                <div data-aos="fade-right" data-aos-delay="100">
                  <h2>Customized</h2>
                  <h2>Solutions</h2>
                </div>
              </div>
            </section>
            <section className="pallet_faq">
              <div className="faq-head">
                <h2>Where Innovation Meets Efficiency.</h2>
                <p>
                  PalletTrader’s technology may be new, but our expertise
                  designing customized pallet solutions goes back 40+ years. In
                  partnership with Bettaway Pallet Systems, we can satisfy any
                  pallet challenge you throw our way. Whether you have a few
                  regional locations, or a national presence, we have experts
                  ready to solve your more complex pallet problems.
                </p>
              </div>
            </section>
            <section className="digital_supplier">
              <div className="digital_supplier_img">
                <img
                  src={DigitalSupplier}
                  alt="icon"
                  data-aos="fade-down"
                  data-aos-delay="100"
                />
              </div>
              <div className="digital_supplier-text">
                <div data-aos="fade-up" data-aos-delay="100">
                  <h2>Tailor-Made for Your Unique Needs.</h2>
                  <p>
                    PalletTrader’s solution architects spend the time to learn
                    about your complex supply chain and how we can bring value
                    and efficiency. Our ultimate goal is to reduce your total
                    cost of ownership (TCO). It doesn’t matter what the program,
                    the results are always the same.
                  </p>
                </div>
              </div>
            </section>
            {/* <section className="what_you_get">
              <div>
                <h2>What You Get.</h2>
              </div>
              <div className="what_you_get_option">
                <div
                  className="img-wrp"
                  data-aos="fade-right"
                  data-aos-delay="000"
                >
                  <div className="gry-bg">
                    <img src={GetIcon1} alt="icon" />
                  </div>
                  <div className="blue-bg">
                    <h3>Process Efficiency</h3>
                  </div>
                </div>
                <div
                  className="img-wrp"
                  data-aos="fade-right"
                  data-aos-delay="300"
                >
                  <div className="gry-bg">
                    <img src={GetIcon2} alt="icon" />
                  </div>
                  <div className="blue-bg">
                    <h3>Network Visibility</h3>
                  </div>
                </div>
                <div
                  className="img-wrp"
                  data-aos="fade-right"
                  data-aos-delay="600"
                >
                  <div className="gry-bg">
                    <img src={GetIcon3} alt="icon" />
                  </div>
                  <div className="blue-bg">
                    <h3>Lowest TCO & Flexible Terms</h3>
                  </div>
                </div>
                <div
                  className="img-wrp"
                  data-aos="fade-right"
                  data-aos-delay="900"
                >
                  <div className="gry-bg">
                    <img src={GetIcon4} alt="icon" />
                  </div>
                  <div className="blue-bg">
                    <h3>Expert Resources</h3>
                  </div>
                </div>
              </div>
            </section> */}

            <div className="what_you_get" ref={whatRef}>
              <div className="what_you_get-container">
                <h2>What you get.</h2>
                {/* <p>All the Tools. All the Technology. It's All You Need</p> */}

                <div className="cards-container">
                  {data?.map((item, index) => (
                    <CardDetails
                      key={"card-item" + index}
                      item={item}
                      index={index}
                      isOpen={openIndex === index}
                      onOpen={() => handleOpen(index)}
                      onClose={handleClose}
                    />
                  ))}
                </div>
              </div>
            </div>

            <section className="pallet_faq" id="our" ref={ourRef}>
              <div className="faq-head">
                <h2 className="our">Our Specialties.</h2>
                <p>
                  Custom solutions leveraging over 40 years of pallet industry
                  experience to deliver the lowest TCO.
                </p>
              </div>
            </section>
            <section className="color_box_wrp mb-0">
              <ColorBox data-aos="flip-up" data-aos-delay="000">
                <div className="color_head blue">
                  <img src={Specialties1} alt="icon" />
                  <h4>Hybrid Program Management</h4>
                </div>
                <div className="color_body gry">
                  <p>
                    We are experts at managing hybrid needs, traditional rental pool and white-wood pallets, under one
                    centralized program. This centralized, one-point-of-contact approach streamlines your pallet operations
                    and invoicing processes, ultimately leading to process efficiency and an overall cost savings.
                  </p>
                </div>
              </ColorBox>
              <ColorBox data-aos="flip-up" data-aos-delay="100">
                <div className="color_head sky">
                  <img src={Specialties2} alt="icon" />
                  <h4>Repair & Return (R&R) Programs</h4>
                </div>
                <div className="color_body light_sky">
                  {/* <p>Repair & return (R&R) Programs</p> */}
                  <p>
                    Our comprehensive repair and return (R&amp;R) programs bring tons of value to your supply chain, keeping
                    waste reduction and cost savings in mind. We will analyze your network to identify potential
                    opportunities to introduce such programs, and manage the process from start to finish. These programs
                    are optimal for semi- closed loops, or closed loop supply chains looking to reduce their overall TCO.
                  </p>
                </div>
              </ColorBox>
              <ColorBox data-aos="flip-up" data-aos-delay="100">
                <div className="color_head ocean">
                  <img src={Specialties3} alt="icon" />
                  <h4>Private Block Pool</h4>
                </div>
                <div className="color_body gry">
                  {/* <p>Private Block Pallets Pool Management</p> */}
                  <p>
                    We offer a fully managed, private block pool platform with no upfront capital expense that is great for
                    larger enterprises with a closed-loop supply chains. This program provides ultimate supply assurance
                    and guarantees more consistent, better quality pallets. It comes with tracking devices to improve cycle
                    time and reduce costs.
                  </p>
                  {/* <ul>
                    <li>
                      Block pallets ownership without upfront capital expense
                    </li>
                    <li>Supply assurance & consistent better quality</li>
                    <li>
                      Tracking devices to improve cycle time & reduce cost
                    </li>
                  </ul> */}
                </div>
              </ColorBox>

              <ColorBox data-aos="flip-up" data-aos-delay="000">
                <div className="color_head blue">
                  <img src={Specialties4} alt="icon" />
                  <h4>White Wood Pallet Deposit & Redemption Programs</h4>
                </div>
                <div className="color_body gry">
                  {/* <p>Pallet Deposit & Redemption Programs</p> */}
                  <p>
                    We implement and manage white-wood pallet deposit programs, bringing ultimate efficiency to your
                    supply chains to recapture valuable pallets. These programs are especially designed for larger
                    enterprises that have a high velocity of pallets down-streaming into traditional distributors.
                  </p>
                  {/* <ul>
                    <li>You charge distributors a deposit for the pallets</li>
                    <li>
                      We recover the pallets from your distributors and buy them
                      back from you
                    </li>
                  </ul> */}
                </div>
              </ColorBox>
              <ColorBox data-aos="flip-up" data-aos-delay="100">
                <div className="color_head ocean">
                  <img src={Specialties6} alt="icon" />
                  <h4>Value Engineering</h4>
                </div>
                <div className="color_body gry">
                  {/* <p>Value Engineering</p> */}
                  <p>
                    We assess your pallet unit load to improve pallet utilization and reduce damage.
                  </p>
                </div>
              </ColorBox>
              <ColorBox data-aos="flip-up" data-aos-delay="100">
                <div className="color_head sky">
                  <img src={Specialties5} alt="icon" />
                  <h4>Custom Developed Pallet Solutions</h4>
                </div>
                <div className="color_body light_sky">
                  {/* <p>Custom Pallet Solutions</p> */}
                  <p>
                    There is no supply chain that we can’t help with. We are all about collecting data, learning about your
                    pain-points, then delivering a tailor-made pallet solution fit to you. Our goal is to bring efficiency and
                    deliver cost savings to you.
                  </p>
                </div>
              </ColorBox>
            </section>
            <section className="pallet_faq">
              <div className="faq-head">
                <h2 className="market">
                  Contact a Solutions Architect. Search the Marketplace.
                </h2>
                <h2 className="market">Experience Innovation.</h2>
                <ButtonSet />
              </div>
            </section>
          </Wrapper>
        </Container>
        <LandingFooter />
      </PublicLayout>
    </>
  );
};

export default CustomizedSolutions;
